import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { AbstractPersonalUserDataService } from 'src/app/moov-common/services/personal-user-data/personal-user-data.abstract.service';
import { LocalStorageService } from '../../../moov-common/services/localStorage';
import { AbstractLocalStorageService } from '../../../moov-common/services/localStorage/local-storage.abstract.service';
import { LocalStorageKeys } from '../../../moov-common/services/localStorage/local-storage.enum';
import { PersonalUserDataService } from '../../../moov-common/services/personal-user-data/personal-user-data.service';
import { NAVIGATION_ROUTES } from '../../../navigation-routes.const';

@Injectable()
export class AuthGuardService  {
  constructor(public router: Router, public localStorageService: AbstractLocalStorageService, public personalUserDataService: AbstractPersonalUserDataService) { }
  
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.personalUserDataService.isUserLoggedIn()) {
      this.localStorageService.write<string>(LocalStorageKeys.returnUrl, state.url);
      this.localStorageService.clear(LocalStorageKeys.moovToken);
      this.localStorageService.clear(LocalStorageKeys.userPersonalInfo);
      console.log('AuthGuardService: User is not logged in, redirecting to login page and clearing local storage');
      
      this.router.navigate([NAVIGATION_ROUTES.login], { state: { redirect: state.url } });
      
      return false;
    } else {
      return true;  
    }
    
  }}